/**
 *  <gh-view-editor-light> — restricted view editor
 *
 *  Like <gh-view-editor> but with two constraints:
 *    - Containers cannot be moved (no drag-and-drop on gh_flex containers)
 *    - Container settings toolbar (<pencil-container-settings>) is not shown
 *  Elements within gh_float containers can still be repositioned via drag-and-drop.
 *
 *  ATTRIBUTES:
 *  'app-id'    - Application ID to load views from
 *  'view-id'   - ID of the specific view to edit; edits first view if omitted
 *  'decorator' - Two-way binding to a view model object (overrides app-id/view-id lookup)
 **/

import { contextMenuHandler } from './gh_view_editor_light_context_menu.js';
import * as Element from './views/element_editor_light.js';
import * as Flex from './views/flex_editor_light.js';
import * as Float from './views/float_editor_light.js';
import * as Tabs from './views/tabs_editor_light.js';
import * as Dropdown from './views/dropdown_editor_light.js';

let Templates = [Element, Flex, Float, Tabs, Dropdown];

angular.module('GhTemplateEditorLightModule', ['localizationModule'])

.directive("ghViewEditorLight", ['$animate', function($animate) {

    let directive = {
        template:
            `<div class="ghViewContainer ghEditor" ng-repeat="list in views = [model]">
                <ul class="ghViewContainerList" ng-init="lists = list.content">
                    <li class="ghViewContainerListItem" ng-class="item.class" ng-repeat="item in lists | orderBy:'priority'"
                    ng-include="item.template_id + '_editor_light'"></li>
                </ul>
            </div>`,
        replace: false,
        restrict: 'E',
        controller: controller,
        scope: {
            appId: '@',
            viewId: '@',
            decorator: '=?'
        }
    };

    controller.$inject = ['$scope', 'formEditorService', '$element', 'PipeService', 'viewTemplatesLightStorage', 'cnfg', '$location', '$route', 'GhElementEditor', 'GhElementEditorLight', 'Message', 'localizationService'];

    async function controller($scope, formEditorService, $element, PipeService, viewTemplatesLightStorage, cnfg, $location, $route, GhElementEditor, GhElementEditorLight, Message, localizationService) {
        $scope.templates = viewTemplatesLightStorage.getContainersTemplates();

        $animate.enabled(false, $element);

        //-----------------------------------------------

        $scope.model = {};

        function update(newVal) {
            $scope.model = getView(newVal);
        }

        function getView(data) {
            let view = {};

            if ($scope.viewId) {
                angular.forEach(data, function(value) {
                    if (value.view_id == $scope.viewId) view = value;
                });
            } else {
                view = data[0];
            }

            return view;
        }

        let address = {
            app_id: $scope.appId
        };

        if ($scope.appId) {
            const views_list = await gudhub.appProcessor.getAppViews($scope.appId);
            update(views_list);
            PipeService.on('gh_app_views_update', address, viewsUpdatePipe);
        }

        function viewsUpdatePipe(_event, data) {
            update(data);
        }

        const handleContextMenuEditorLight = contextMenuHandler($scope, { cnfg, $location, $route, formEditorService, GhElementEditor, GhElementEditorLight, Message, PipeService, $element, localizationService });
        window.addEventListener('contextmenu', handleContextMenuEditorLight);

        $scope.$on('$destroy', function() {
            PipeService.destroy('gh_app_views_update', address, viewsUpdatePipe);
            window.removeEventListener('contextmenu', handleContextMenuEditorLight);
        });

        $scope.$watch('decorator', function(newDecorator) {
            if (newDecorator) {
                $scope.model = newDecorator;
            }
        }, true);

        //-----------------------------------------------

        $scope.saveModelElement = {};
        $scope.getElementModelT = function(element_id) {
            if (element_id) {
                angular.copy(formEditorService.getElementModel(element_id), $scope.saveModelElement);

                return $scope.saveModelElement;
            }
        };

        $scope.dropElement = function(index, items, external, type, lists) {
            formEditorService.dropElement();
            if (items.length) {
                for (let i = 0; i < items.length; i++) {
                    lists.splice(index + i, 0, items[i]);
                    formEditorService.addElementToExisting(items[i].data_model);
                }
            } else {
                return items;
            }
        };

        $scope.insertedElement = function() {
            addAllowedTypesLight($scope.model);
        };

        function addAllowedTypesLight(model) {
            formEditorService.crawling(model, function(prop, value, parent) {
                if (prop === 'template_id' && value === 'gh_float') {
                    let hasContainerChild = parent.content && parent.content.some(
                        child => child.template_id !== 'gh_element'
                    );
                    parent.allowed_types = hasContainerChild ? [] : ['gh_element'];
                }
            });
        }
    }

    return directive;
}])


.service('viewTemplatesLightStorage', ['$templateCache', 'localizationService', function($templateCache, localizationService) {

    let _dictionary = null;

    (function loadTemplates() {
        angular.forEach(Templates, function(value) {
            $templateCache.put(value.default.model.template_id + '_editor_light', value.default.html);
        });
    }());

    this.setDictionary = function(dictionary) {
        _dictionary = dictionary;
    };

    this.getContainersTemplates = function() {
        if (!_dictionary) return Templates;
        const translatedDefaults = localizationService.translateTemplates(
            Templates.map(function(t) { return t.default; }),
            _dictionary
        );
        return Templates.map(function(t, i) {
            return { default: translatedDefaults[i] };
        });
    };
}]);
